import { getDataString, getLastDay } from "../../util/Months";

const data = new Date();

const InitialDashboard ={
    isLoadingCards: false,
    isLoadingDays: false,
    cards:{
        0: [
            {
                "Active": false,
                "type": 0,
                "focus": true,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            }
        ],
    },
    name: '',
    hasMoreCards: {
        0: false,
    },
    days: new Array(parseInt(getLastDay(getDataString(data.getMonth()+1)))).fill(null),
    day: getDataString(data.getDate()),
    month: getDataString(data.getMonth()+1),
    year: data.getFullYear(),
    Equipamentos: [],
    donutGraph:[
        {
          "id": "green",
          "label": "Econômico",
          "value": 0,
          "color": "#3C9"
        },
        {
          "id": "yellow",
          "label": "Moderado",
          "value": 0,
          "color": "#EABC1A"
        },
        {
          "id": "red",
          "label": "Excessivo",
          "value": 0,
          "color": "#FF3939"
        }
    ],
    Mode: 0,
    status: 0,
    title: '',
    dados: [],
    CardStatus: 0
}

export default function DashboardGeralReducer ( PrevState = InitialDashboard, action){
    switch (action.type) {
        case 'ChangedashCards':
            return{
                ...PrevState,
                cards : action.payload.cards,
                name : action.payload.name
            };
        case 'ChangedashTotalCards':
            return{
                ...PrevState,
                hasMoreCards : {
                    ...PrevState.hasMoreCards,
                    ...action.payload.hasMoreCards
                },
            };
        case 'ChangedashDays' :
            return{
                ...PrevState,
                days: action.payload.days
            };
        case 'ChangedashDay':
            return {
                ...PrevState,
                day: action.payload.day
            };
        case 'ChangedashMonth':
            return {
                ...PrevState,
                month: action.payload.month
            };
        case 'ChangedashCardsLoading' :
            return{
                ...PrevState,
                isLoadingCards : action.payload.isLoading
            };
        case 'ChangedashDaysLoading' :
            return{
                ...PrevState,
                isLoadingDays : action.payload.isLoading
            };
        case 'changedashyear':
            return {
                ...PrevState,
                year: action.payload.year
            };
        case 'changeDonutData':
            return {
                ...PrevState,
                donutGraph: action.payload.donutGraph
            };
        case 'ChangeDashMode':
            return {
                ...PrevState,
                Mode: action.payload.mode
            };
        case 'changeTitle':
            return {
                ...PrevState,
                title: action.payload.title
            };
        case 'changeStatus':
            return {
                ...PrevState,
                status: action.payload.status
            };
        case 'ChangeDados':
            return {
                ...PrevState,
                dados: action.payload.dados
            };
        case 'ChangeCardStatus':
            return { 
                ...PrevState,
                CardStatus: action.payload.status
            };
        default:
            return PrevState;
    }
}